import { DefaultRootState } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';

export const ecgCounterStateSelector = ({ counter }: DefaultRootState) =>
  counter;

export const ecgCounterSelector = createSelector(
  ecgCounterStateSelector,
  ({ counter }) => counter,
);

export const currentEcgIdSelector = createSelector(
  ecgCounterStateSelector,
  ({ currentEcgId }) => currentEcgId,
);
